import React, { useContext, useEffect, useRef } from 'react';
import BaseForm from '../../../../../core/page/components/baseForm/BaseForm';
import Pages from '../../../../../config/Pages';
import { inputsDadosComplementares } from '../../PageInputs';
import InputDropDown from '../../../../../core/components/inputs/inputDropDown/InputDropDown';
import InputFile from '../../../../../core/components/inputs/inputFile/InputFile';
import { InputTextarea } from 'primereact/inputtextarea';
import { Fieldset } from 'primereact/fieldset';
import styles from './FormDadosComplementares.module.scss';
import Radio from '../../../../../core/components/inputs/radio/Radio';
import Buttons from '../Buttons';
import NomeIndicadorView from '../inputNomeIndicador/InputNomeIndicador';
import InputTextLengthCounter from '../../../../../core/components/inputs/inputTextLengthCounter/InputTextLengthCounter';
import FieldWithInfo from '../FieldWithInfo';
import { MultipageContext } from '../../../../../core/components/Multipage';
import propostaIndicadorService from '../../../../../service/PropostaIndicadorService';
import unidadeMedidaIntegracaoService from '../../../../../service/integracao/UnidadeMedidaIntegracaoService';
import periodicidadeIntegracaoService from '../../../../../service/integracao/PeriodicidadeIntegracaoService';
import desagregacaoGeograficaService from '../../../../../service/DesagregacaoGeograficaService';
import desagregacaoCategoricaService from '../../../../../service/DesagregacaoCategoricaService';
import compreensaoResultadoService from '../../../../../service/CompreensaoResultadoService';
import Chips from '../chips/Chips';
import fonteService from '../../../../../service/FonteService';
import { printToast } from '../../../../../core/utils/Global';
import Shareds from '../../../../../config/translations/Shareds';
import arquivoIntegracaoService from '../../../../../service/integracao/ArquivoIntegracaoService';
import { blobToFile } from '../../../../../core/utils/Exporter';
import indicadorService from '../../../../../service/IndicadorService';
import stylesDiff from '../Utils.module.scss';

function FormDadosComplementares({ isView, disableButtonVoltar, onFind }) {
    const { idProposta, confirmRef, multipageRef, voltarUrl, idIndicador } =
        useContext(MultipageContext);
    const dadosIndicadorRef = useRef(null);
    const formRef = useRef(null);

    useEffect(() => {
        formRef.current?.onLoad();
    }, []);

    const hasDiffFontes = (formik) => {
        if (idIndicador) {
            const fontesIndicador = dadosIndicadorRef.current?.fontes
                ? dadosIndicadorRef.current?.fontes
                : dadosIndicadorRef.current?.fonteIndicadores ?? [];
            return fontesIndicador.length !== formik.values?.fontes.length
                ? stylesDiff.hasDiffChip
                : '';
        }

        return '';
    };

    const Inputs = ({ formik, formController }) => (
        <form className={`p-col-12 p-grid p-fluid ${styles.form}`}>
            <NomeIndicadorView disabled />
            <FieldWithInfo
                formController={formController}
                formik={formik}
                id="unidadeMedida"
                cols="12 6"
                className={
                    idIndicador &&
                    dadosIndicadorRef.current?.unidadeMedida?.codigoUnidadeMedida !==
                        formik.values?.unidadeMedida?.codigoUnidadeMedida
                        ? stylesDiff.hasDiff
                        : ''
                }
            >
                <InputDropDown
                    formik={formik}
                    valueIsCompleteObject
                    optionValue="codigoUnidadeMedida"
                    optionLabel="descUnidadeMedida"
                    callbackSetList={unidadeMedidaIntegracaoService.list.bind(
                        unidadeMedidaIntegracaoService
                    )}
                    disabled={isView}
                />
            </FieldWithInfo>
            <FieldWithInfo
                formController={formController}
                formik={formik}
                id="periodicidadeIndicador"
                cols="12 6"
                className={
                    idIndicador &&
                    dadosIndicadorRef.current?.periodicidadeIndicador?.idenPeriodicidade !==
                        formik.values?.periodicidadeIndicador?.idenPeriodicidade
                        ? stylesDiff.hasDiff
                        : ''
                }
            >
                <InputDropDown
                    formik={formik}
                    valueIsCompleteObject
                    optionValue="idenPeriodicidade"
                    optionLabel="siglaPeriodicidade"
                    callbackSetList={periodicidadeIntegracaoService.list.bind(
                        periodicidadeIntegracaoService
                    )}
                    disabled={isView}
                />
            </FieldWithInfo>
            <FieldWithInfo
                formController={formController}
                formik={formik}
                id="desagregacaoGeografica"
                cols="12 6"
                className={
                    idIndicador &&
                    dadosIndicadorRef.current?.desagregacaoGeografica?.id !==
                        formik.values?.desagregacaoGeografica?.id
                        ? stylesDiff.hasDiff
                        : ''
                }
            >
                <InputDropDown
                    formik={formik}
                    valueIsCompleteObject
                    optionLabel="descDesagregacaoGeografica"
                    callbackSetList={desagregacaoGeograficaService.list.bind(
                        desagregacaoGeograficaService
                    )}
                    disabled={isView}
                />
            </FieldWithInfo>
            <FieldWithInfo
                formController={formController}
                formik={formik}
                id="desagregacaoCategorica"
                cols="12 6"
                className={
                    idIndicador &&
                    dadosIndicadorRef.current?.desagregacaoCategorica?.id !==
                        formik.values?.desagregacaoCategorica?.id
                        ? stylesDiff.hasDiff
                        : ''
                }
            >
                <InputDropDown
                    formik={formik}
                    valueIsCompleteObject
                    optionLabel="descDesagregacaoCategorica"
                    callbackSetList={desagregacaoCategoricaService.list.bind(
                        desagregacaoCategoricaService
                    )}
                    disabled={isView}
                />
            </FieldWithInfo>
            <FieldWithInfo
                formController={formController}
                formik={formik}
                id="descMetodologia"
                cols="12 6"
                className={
                    idIndicador &&
                    dadosIndicadorRef.current?.descMetodologia !== formik.values?.descMetodologia
                        ? stylesDiff.hasDiff
                        : ''
                }
            >
                <InputTextLengthCounter maxLen={300}>
                    <InputTextarea
                        value={formik.values.descMetodologia}
                        onChange={formik.handleChange}
                        rows={4}
                        keyfilter={/^[A-Za-z0-9-à-ú-À-Ú ]|[!"#$%&'()*+,-./:;?@[\\\]_`{|}~<>=]/}
                        disabled={isView}
                    />
                </InputTextLengthCounter>
            </FieldWithInfo>
            <FieldWithInfo
                formController={formController}
                formik={formik}
                id="arquivoMetodologiaCalculo"
                cols="12 6"
            >
                <InputFile
                    formik={formik}
                    thumb={<div className={styles.thumb}>PDF</div>}
                    accept="application/pdf"
                    disabled={isView}
                />
            </FieldWithInfo>
            <FieldWithInfo
                formController={formController}
                formik={formik}
                id="descInterpretacaoUso"
                cols="12"
                className={
                    idIndicador &&
                    dadosIndicadorRef.current?.descInterpretacaoUso !==
                        formik.values?.descInterpretacaoUso
                        ? stylesDiff.hasDiff
                        : ''
                }
            >
                <InputTextLengthCounter maxLen={500}>
                    <InputTextarea
                        value={formik.values.descInterpretacaoUso}
                        onChange={formik.handleChange}
                        rows={4}
                        disabled={isView}
                    />
                </InputTextLengthCounter>
            </FieldWithInfo>
            <FieldWithInfo
                formController={formController}
                formik={formik}
                id="fontes"
                cols="12"
                className={hasDiffFontes(formik)}
            >
                <Chips
                    value={formik.values.fontes}
                    onChange={(n, v) => formik.setFieldValue(n, v)}
                    onDelete={async ({ el, removeList }) => {
                        if (el?.id) {
                            await fonteService.remover(el);
                            printToast({
                                severity: 'success',
                                summary: Pages.sei.propostaIndicador.title,
                                detail: Shareds.form.successDelete,
                            });
                        }
                        removeList();
                    }}
                    disabled={isView}
                />
            </FieldWithInfo>
            <FieldWithInfo
                formController={formController}
                formik={formik}
                id="descPesquisaDados"
                cols="12"
                className={
                    idIndicador &&
                    dadosIndicadorRef.current?.descPesquisaDados !==
                        formik.values?.descPesquisaDados
                        ? stylesDiff.hasDiff
                        : ''
                }
            >
                <InputTextLengthCounter maxLen={200}>
                    <InputTextarea
                        value={formik.values.descPesquisaDados}
                        onChange={formik.handleChange}
                        rows={4}
                        disabled={isView}
                    />
                </InputTextLengthCounter>
            </FieldWithInfo>
            <FieldWithInfo
                formController={formController}
                formik={formik}
                id="descInformacaoComplementar"
                cols="12"
                className={
                    idIndicador &&
                    dadosIndicadorRef.current?.descInformacaoComplementar !==
                        formik.values?.descInformacaoComplementar
                        ? stylesDiff.hasDiff
                        : ''
                }
            >
                <InputTextLengthCounter maxLen={500}>
                    <InputTextarea
                        value={formik.values.descInformacaoComplementar}
                        onChange={formik.handleChange}
                        rows={4}
                        disabled={isView}
                    />
                </InputTextLengthCounter>
            </FieldWithInfo>
            <FieldWithInfo
                formController={formController}
                formik={formik}
                id="descLimitacao"
                cols="12 6"
                className={
                    idIndicador &&
                    dadosIndicadorRef.current?.descLimitacao !== formik.values?.descLimitacao
                        ? stylesDiff.hasDiff
                        : ''
                }
            >
                <InputTextLengthCounter maxLen={200}>
                    <InputTextarea
                        value={formik.values.descLimitacao}
                        onChange={formik.handleChange}
                        rows={4}
                        disabled={isView}
                    />
                </InputTextLengthCounter>
            </FieldWithInfo>
            <FieldWithInfo
                formController={formController}
                formik={formik}
                id="descParametroComparacao"
                cols="12 6"
                className={
                    idIndicador &&
                    dadosIndicadorRef.current?.descParametroComparacao !==
                        formik.values?.descParametroComparacao
                        ? stylesDiff.hasDiff
                        : ''
                }
            >
                <InputTextLengthCounter maxLen={200}>
                    <InputTextarea
                        value={formik.values.descParametroComparacao}
                        onChange={formik.handleChange}
                        rows={4}
                        disabled={isView}
                    />
                </InputTextLengthCounter>
            </FieldWithInfo>
            <FieldWithInfo
                formController={formController}
                formik={formik}
                id="descRecomendacao"
                cols="12"
                className={
                    idIndicador &&
                    dadosIndicadorRef.current?.descRecomendacao !== formik.values?.descRecomendacao
                        ? stylesDiff.hasDiff
                        : ''
                }
            >
                <InputTextLengthCounter maxLen={500}>
                    <InputTextarea
                        value={formik.values.descRecomendacao}
                        onChange={formik.handleChange}
                        rows={4}
                        disabled={isView}
                    />
                </InputTextLengthCounter>
            </FieldWithInfo>
            <FieldWithInfo
                formController={formController}
                formik={formik}
                id="compreensaoResultado"
                cols="12"
                className={
                    idIndicador &&
                    dadosIndicadorRef.current?.compreensaoResultado?.id !==
                        formik.values?.compreensaoResultado?.id
                        ? stylesDiff.hasDiff
                        : ''
                }
            >
                <InputDropDown
                    formik={formik}
                    valueIsCompleteObject
                    callbackSetList={compreensaoResultadoService.list.bind(
                        compreensaoResultadoService
                    )}
                    optionLabel="descCompreensaoResultado"
                    disabled={isView}
                />
            </FieldWithInfo>
            <Fieldset
                legend="Restrição ao Uso da Informação: Discorrer sobre existência de restrição ao uso da informação"
                className={`${styles.fieldset} ${styles.radiosContainer}`}
            >
                <FieldWithInfo
                    formController={formController}
                    formik={formik}
                    id="restricaoPublicacaoDados"
                    cols="12"
                    horizontal
                    className={`${styles.containerRadio} ${
                        idIndicador &&
                        dadosIndicadorRef.current?.restricaoPublicacaoDados !==
                            formik.values?.restricaoPublicacaoDados
                            ? stylesDiff.hasDiffRadio
                            : ''
                    }`}
                >
                    <div>
                        <Radio
                            name="restricaoPublicacaoDados"
                            label="Sim"
                            value={true}
                            formik={formik}
                            disabled={isView}
                        />
                        <Radio
                            name="restricaoPublicacaoDados"
                            label="Não"
                            value={false}
                            formik={formik}
                            disabled={isView}
                        />
                    </div>
                </FieldWithInfo>
                <FieldWithInfo
                    formController={formController}
                    formik={formik}
                    id="restricaoPublicacaoExcetoOrgao"
                    cols="12"
                    horizontal
                    className={`${styles.containerRadio} ${
                        idIndicador &&
                        dadosIndicadorRef.current?.restricaoPublicacaoExcetoOrgao !==
                            formik.values?.restricaoPublicacaoExcetoOrgao
                            ? stylesDiff.hasDiffRadio
                            : ''
                    }`}
                >
                    <div>
                        <Radio
                            name="restricaoPublicacaoExcetoOrgao"
                            label="Sim"
                            value={true}
                            formik={formik}
                            disabled={isView}
                        />
                        <Radio
                            name="restricaoPublicacaoExcetoOrgao"
                            label="Não"
                            value={false}
                            formik={formik}
                            disabled={isView}
                        />
                    </div>
                </FieldWithInfo>
                <FieldWithInfo
                    formController={formController}
                    formik={formik}
                    id="restricaoPublicacaoExcetoUso"
                    cols="12"
                    horizontal
                    className={`${styles.containerRadio} ${
                        idIndicador &&
                        dadosIndicadorRef.current?.restricaoPublicacaoExcetoUso !==
                            formik.values?.restricaoPublicacaoExcetoUso
                            ? stylesDiff.hasDiffRadio
                            : ''
                    }`}
                >
                    <div>
                        <Radio
                            name="restricaoPublicacaoExcetoUso"
                            label="Sim"
                            value={true}
                            formik={formik}
                            disabled={isView}
                        />
                        <Radio
                            name="restricaoPublicacaoExcetoUso"
                            label="Não"
                            value={false}
                            formik={formik}
                            disabled={isView}
                        />
                    </div>
                </FieldWithInfo>
            </Fieldset>
        </form>
    );
    return (
        <>
            <BaseForm
                ref={formRef}
                onBuscar={async (form) => {
                    const response = await onFind(idProposta, form);

                    if (idIndicador) {
                        const responseIndicador = await indicadorService.getDadosComplementares(
                            idIndicador,
                            form
                        );
                        dadosIndicadorRef.current = responseIndicador;
                    }

                    return response;
                }}
                actionOnSave={({ success }) => {
                    if (success) {
                        formRef.current?.onLoad();
                    }
                }}
                onValidate={() => null}
                onSubmit={({ registro }) =>
                    propostaIndicadorService.saveDadosComplementares(idProposta, registro)
                }
                prepareInitialValues={async ({
                    arquivoMetodologiaCalculo,
                    fonteIndicadores,
                    fontes,
                    ...dados
                }) => {
                    if (!arquivoMetodologiaCalculo?.id) {
                        return {
                            ...dados,
                            fontes: Array.isArray(fontes) ? fontes : fonteIndicadores,
                            arquivoMetodologiaCalculo,
                        };
                    }
                    const response = await arquivoIntegracaoService.getArquivoById(
                        arquivoMetodologiaCalculo?.id
                    );

                    return {
                        ...dados,
                        fontes: Array.isArray(fontes) ? fontes : fonteIndicadores,
                        arquivoMetodologiaCalculo: blobToFile(
                            response,
                            arquivoMetodologiaCalculo?.nomeArquivo
                        ),
                    };
                }}
                buscarOnLoad={false}
                redirectOnSave={false}
                page={Pages.sei.propostaIndicador}
                initialValues={inputsDadosComplementares.filter(
                    (input) => input?.form?.use ?? false
                )}
            >
                <Inputs />
            </BaseForm>
            <Buttons
                disableButtonVoltar={disableButtonVoltar}
                isView={isView}
                onVoltar={() => {
                    const voltar = () =>
                        multipageRef?.current?.tab?.last !== null
                            ? multipageRef?.current?.alterTab(multipageRef?.current?.tab?.last)
                            : history.push(`${voltarUrl}`);
                    if (formRef.current.verificaAlteracao()) {
                        confirmRef.current?.show(Shareds.form.dontSaveData, () =>
                            setTimeout(() => voltar(), 500)
                        );
                    } else {
                        voltar();
                    }
                }}
                onSalvar={async () => {
                    formRef.current?.formController.addCountClick();
                    formRef.current?.formik?.submitForm();
                }}
            />
        </>
    );
}

export default FormDadosComplementares;
